import React, { useEffect, useMemo, useState } from "react";
import LoadingWrapper from "components/LoadingWrapper";
import ExamMainPagePC from "./platforms/PC";
import { useRouteMatch } from "react-router-dom";
import _ from "underscore";
import useRequest from "utils/useRequest";
import { getExamPaper, getExamInfo, getExamPaperList } from "service/exam";
import Header from "components/Header";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { previewExamContext } from "./context";

interface PageReviewStudentExamProps {}

const PageReviewStudentExam: React.FC<PageReviewStudentExamProps> = () => {
    const [paperId, setPaperId] = useState(""); //试卷id

    const match = useRouteMatch<{
        paperId: string;
        examId: string;
        examType: string;
    }>();
    const [examPaperList, { loading: PaperListloading }] = useRequest(
        () => getExamPaperList(match.params.examId),
        {},
        [match.params.examId]
    ); //获取多试卷列表
    const [getData, { loading, data: paperInfo }] = useRequestFn(getExamPaper);

    const [examInfo, { loading: examLoading }] = useRequest(() =>
        getExamInfo(match.params.examId)
    );

    useEffect(() => {
        if (!examPaperList) return;

        if (examPaperList.length !== 0) {
            setPaperId(examPaperList[0].paperId);
        } else {
            setPaperId("");
        }
    }, [examPaperList]);

    //默认不调用，有paperId的时候在调用
    useEffect(() => {
        if (!paperId) return;
        loadPaperData();
    }, [paperId]);

    //获取选中试卷的题目内容
    async function loadPaperData() {
        try {
            await getData(paperId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    //切换选中项
    const handleCheckedItem = (val: string) => {
        setPaperId(val);
    };

    const examList = useMemo(() => {
        if (!paperInfo) return [];
        const TypeSortList = _.uniq(
            _.map(paperInfo.topics, topic => topic.topicType)
        );
        return _.chain(paperInfo.topics)
            .groupBy("topicType")
            .sortBy((type, key) =>
                TypeSortList.findIndex(item => item === key.toString())
            )
            .map(list => {
                return { topicType: list[0].topicType, list: list };
            })
            .value();
    }, [paperInfo]);

    const [showAnswer, setShowAnswer] = useState(false);

    return (
        <previewExamContext.Provider value={{ showAnswer, setShowAnswer }}>
            <div>
                <Header />
                <LoadingWrapper
                    isEmpty={!examInfo || !paperInfo}
                    loading={loading || examLoading}>
                    {() => (
                        <ExamMainPagePC
                            examType={match.params.examType}
                            paperName={examInfo!.name}
                            score={paperInfo!.score}
                            examList={examList}
                            startTime={examInfo!.startTime}
                            endTime={examInfo!.endTime}
                            onChangeCheckItem={handleCheckedItem}
                            examPaperList={!!examPaperList ? examPaperList : []}
                            paperId={paperId}
                            PaperListloading={PaperListloading}
                            duration={examInfo!.duration}
                            timeType={examInfo!.timeType}
                        />
                    )}
                </LoadingWrapper>
            </div>
        </previewExamContext.Provider>
    );
};

export default PageReviewStudentExam;
